import { GA4React } from "ga-4-react";

const ga4react = new GA4React("G-0P5CQ9CZ5T").initialize();

export interface AnalyticsData {
    path: string;
    search: string;
    title: string;
}

export interface AnalyticsEventData {
    category: string;
    action: string;
    label: string;
}

const trackPathForAnalytics = (data: AnalyticsData) => {
    const { path, search, title } = data;
    ga4react
        .then((ga) => {
            ga.pageview(path, search, title);
            
            
        })
        .catch((err) => console.error(`Analytics failed: ${err}`));
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const trackEventForAnalytics = (data: AnalyticsEventData) => {
    const {category,action,label} = data;
    ga4react
        .then((ga) => {
            ga.event(action,label,category)
            
        })
        .catch((err) => console.error(`Analytics failed: ${err}`));
};

export default trackPathForAnalytics;